import { observable, computed, action, decorate } from "mobx";
import * as mobx from 'mobx';
import { runInAction } from "mobx";

import * as forms from '../communicator/forms';

class StoreForms {

    dialog_type = ''
    form_feedback = {};
    isDialogFeedbackFormOpen = false

    constructor(storeRoot) {
        this.storeRoot = storeRoot;
        this.storeGeneral = this.storeRoot.storeGeneral;
    }

    initForm(formControls) {
        const updatedControls = {
            ...formControls
        };

        Object.keys(formControls).map((key, i) => {
            const updatedFormElement = {
                ...updatedControls[key]
            };

            if ('isRequired' in updatedFormElement.validationRules && updatedFormElement.value === '') {
                updatedFormElement.valid = false;
            } else {
                updatedFormElement.valid = true;
            }

            updatedControls[key] = updatedFormElement;
        });
        
        return updatedControls;
    }

    validateForm(formControls) {
        let formIsValid = true;

        Object.keys(formControls).map((key, i) => {
            if (Object.keys(formControls[key].validationRules).length !== 0 && formControls[key].valid === false) {
                formIsValid = false;
            }
        })

        return formIsValid;
    }

    validateRow(formControls, name, value, valid, touched) {        
        const updatedControls = {
            ...formControls
        };
        const updatedFormElement = {
            ...updatedControls[name]
        };
      
        updatedFormElement.value = value;
        updatedFormElement.touched = touched;
        if ('isRequired' in updatedFormElement.validationRules) {
            updatedFormElement.valid = valid;
        } else {
            updatedFormElement.valid = true;
        }
        updatedControls[name] = updatedFormElement;
        
        return updatedControls;
    }

    async sendFormCallMeBack(form_values) {
        const form_data = {
            from_firstname: form_values['firstname'].value,
            from_lastname: form_values['lastname'].value,
            from_phonenr: form_values['phonenr'].value,
            from_email: form_values['email'].value,
            content: form_values['question'].value
        }
        this.storeGeneral.startLoader();
        try {
            const returnData = await forms.sendFormCallMeBack('callmeback', form_data);
            runInAction(() => {
                this.form_feedback = returnData.data[0];
            })
        } catch (error) {
            runInAction(() => {
                this.state = "error"
            })
        } finally {
            this.storeGeneral.stopLoader();
        }
    }

    async sendFormContact(form_values) {
        const form_data = {
            from_firstname: form_values['firstname'].value,
            from_lastname: form_values['lastname'].value,
            from_email: form_values['email'].value,
            from_phonenr: form_values['phonenr'].value,
            content: form_values['question'].value
        }
        this.storeGeneral.startLoader();
        try {
            const returnData = await forms.sendFormContact('contact', form_data);
            runInAction(() => {
                this.form_feedback = returnData.msg;
                this.openDialogFeedbackForm('vraag/opmerking');
            })
        } catch (error) {
            runInAction(() => {
                this.state = "error"
            })
        } finally {
            this.storeGeneral.stopLoader();
        }
    }

    async sendFormNewsletter(form_values) {
        const firstname = form_values['firstname'].value;
        const lastname = form_values['lastname'].value;
        const email = form_values['email'].value;
        const fullname = [firstname, lastname].filter(Boolean).join(' ').trim();
        const content = fullname !== ''
            ? 'Aanmelding nieuwsbrief via nieuwsbriefpagina. Naam: ' + fullname
            : 'Aanmelding nieuwsbrief via nieuwsbriefpagina.';

        const form_data = {
            from_firstname: firstname,
            from_lastname: lastname,
            from_email: email,
            from_phonenr: '',
            content: content
        };

        this.storeGeneral.startLoader();
        try {
            const returnData = await forms.sendFormNewsletter(form_data);
            runInAction(() => {
                this.form_feedback = returnData.msg;
            })
            return 'success' in returnData.msg;
        } catch (error) {
            runInAction(() => {
                this.form_feedback = { error: true };
            })
            return false;
        } finally {
            this.storeGeneral.stopLoader();
        }
    }

    async sendFormEvent(refEvent, form_values) {
        const form_data = {
            firstname: form_values['firstname'].value,
            middlename: form_values['middlename'].value,
            lastname: form_values['lastname'].value,
            email: form_values['email'].value,
            phonenr: form_values['phonenr'].value,
            guestFirstname: form_values['guestFirstname'].value,
            guestMiddlename: form_values['guestMiddlename'].value,
            guestLastname: form_values['guestLastname'].value,
            guestEmail: form_values['guestEmail'].value,
            question: form_values['question'].value
        }
        this.storeGeneral.startLoader();
        try {
            const returnData = await forms.sendFormEvent(refEvent, form_data);
            runInAction(() => {
                this.form_feedback = returnData.data;
                this.openDialogFeedbackForm('registratie');
            })
        } catch (error) {
            runInAction(() => {
                this.state = "error"
            })
        } finally {
            this.storeGeneral.stopLoader();
        }
    }

    clearFormFeedback() {
        this.form_feedback = {};
    }

    closeDialogFeedbackForm = () => {
        this.isDialogFeedbackFormOpen = false;
    }

    openDialogFeedbackForm = (type) => {
        this.dialog_type = type;
        this.isDialogFeedbackFormOpen = true;
    }
}

decorate(StoreForms, {
    dialog_type: observable,
    form_feedback: observable,
    isDialogFeedbackFormOpen: observable,
    initForm: action,
    clearFormFeedback: action,
    closeDialogFeedbackForm: action,
    openDialogFeedbackForm: action,
    sendFormCallMeBack: action,
    sendFormContact: action,
    sendFormEvent: action,
    sendFormNewsletter: action,
    validateForm: action,
    validateRow: action
})

export default StoreForms;
